import React from 'react';

import CalloutBadge from '@rover/components/src/callouts/CalloutBadge/CalloutBadge';
import { Box, Flex } from '@rover/kibble/core';
import Avatar from '@rover/kibble/patterns/Avatar';
import Row from '@rover/kibble/patterns/Row';
import useTheme from '@rover/kibble/themes/useTheme';

export interface Props {
  profileImage?: string | null;
  sitterName?: string;
  headline?: string;
  onClick?: () => void;
}

const ProfileSummaryPreview: React.FC<Props> = ({
  profileImage,
  sitterName,
  headline,
  onClick,
}) => {
  const theme = useTheme();

  if (!profileImage || !sitterName || !headline) {
    return null;
  }

  return (
    <Box>
      <Box
        background="primary"
        borderRadius="primary"
        variant="elevation_low"
        py="1x"
        px="3x"
        display="flex"
        onPress={onClick}
        sx={onClick ? { cursor: 'pointer' } : undefined}
      >
        <Flex flex="1">
          <Row
            label={headline}
            leftItem={<Avatar imageUrl={profileImage} alt={sitterName} />}
            sublabel={sitterName}
          />
        </Flex>
        <Flex mt="2x" mr="1x">
          <CalloutBadge
            value="PREVIEW"
            styleOverrides={{
              'background-color': theme.background.tertiary,
              color: theme.colors.text.secondary,
              'border-radius': theme.radii.secondary,
              height: 16,
              'line-height': '1.1',
            }}
          />
        </Flex>
      </Box>
    </Box>
  );
};

export default ProfileSummaryPreview;
